import { Component, OnInit, Input, ElementRef, Output, EventEmitter, Renderer2, ViewChild } from '@angular/core';
import { fromEvent,merge } from 'rxjs';
import { filter, take, startWith,map } from 'rxjs/operators';
export enum TypeDrag {
  Move,
  Top,
  Bottom,
  Left,
  Right,
  TopRight,
  BottomRight,
  TopLeft,
  BottomLeft
}

@Component({
  selector: 'resize-border',
  templateUrl: './resize-border.component.html',
  styleUrls: ['./resize-border.component.scss']
})
export class ResizeBorderComponent implements OnInit {
  rect: any;
  incr: number[] = [0, 0, 0, 0];
  nativeElement: any;
  typeDrag: TypeDrag;
  origin: any;
  onDrag: boolean = false;
  moveSubscription: any;
  modalContent: any;
  @Output() sizeStyle:any = new EventEmitter();

  classNames = [
    'cell-top',
    'cell-border-top',
    'cell-border-bottom',
    'cell-border-left',
    'cell-border-right',
    'cell-top-right',
    'cell-bottom-right',
    'cell-top-left',
    'cell-bottom-left'
  ];

  style: any = {
      width: '100%',
      height: '100%'
    };;
  constructor(private elementRef: ElementRef) {}

  @Input() set dragHolder(value: { classList: { add: (arg0: string) => void; }; }) {
    value.classList.add('cell-top');
  }

  ngOnInit(): void { window.scroll({top:0,left:0,behavior:"smooth"});
    this.modalContent = this.findModalContent(this.elementRef.nativeElement);
    this.modalContent.parentElement.style['max-width'] = '500px';
    this.modalContent.parentElement.style['height'] ='606px';
    // this.modalContent.style['margin'] ='';
    merge(
    fromEvent(this.elementRef.nativeElement, 'mousedown'),
    fromEvent(this.elementRef.nativeElement, 'touchstart').pipe(map((event:TouchEvent)=>({
      target:event.target,
      screenX:event.touches[0].screenX,
      screenY:event.touches[0].screenY
    }))
    ))
      .pipe(
        filter((event: MouseEvent) => {
          const classs = (event.target as any).className;
          if (classs && typeof classs === 'string') {
            const className = classs.split(' ');
            return className.indexOf('cell-top') >= 0
              ? true
              : this.classNames.indexOf(classs) >= 0;
          }
          return false;
        })
      )
      .subscribe((event: MouseEvent) => {
        this.rect = this.modalContent.getBoundingClientRect();
        console.log(typeof(event))
        this.origin =  { x: event.screenX, y: event.screenY };

        this.onDrag = true;
        const className = (event.target as any).className.split(' ');
        this.typeDrag =
          className.indexOf('cell-top') >= 0
            ? TypeDrag.Move
            : (this.classNames.indexOf(className[0]) as TypeDrag);

        this.incr =
          this.typeDrag == TypeDrag.Move
            ? [1, 0, 1, 0]
            : this.typeDrag == TypeDrag.Top
            ? [1, -1, 0, 0]
            : this.typeDrag == TypeDrag.Bottom
            ? [0, 1, 0, 0]
            : this.typeDrag == TypeDrag.Right
            ? [0, 0, 0, 1]
            : this.typeDrag == TypeDrag.Left
            ? [0, 0, 1, -1]
            : this.typeDrag == TypeDrag.TopRight
            ? [1, -1, 0, 1]
            : this.typeDrag == TypeDrag.TopLeft
            ? [1, -1, 1, -1]
            : this.typeDrag == TypeDrag.BottomRight
            ? [0, 1, 0, 1]
            : [0, 1, 1, -1];

        this.onDrag = true;

        merge(fromEvent(document, 'mouseup'),
              fromEvent(document,'touchend')
        )
          .pipe(take(1))
          .subscribe(() => {
            if (this.moveSubscription) {
              this.moveSubscription.unsubscribe();
              this.moveSubscription = undefined;
              this.onDrag = false;
            }
          });

        if (!this.moveSubscription) {
          this.moveSubscription = merge(
            fromEvent(document, 'mousemove'),
            fromEvent(document, 'touchmove').pipe(map((event:TouchEvent)=>({
              target:event.target,
              screenX:event.touches[0].screenX,
              screenY:event.touches[0].screenY
            }))
            ))
            .pipe(startWith({ screenY: this.origin.y, screenX: this.origin.x }))
            .subscribe((moveEvent: MouseEvent) => {
              const incrTop = moveEvent.screenY - this.origin.y;
              const incrLeft = moveEvent.screenX - this.origin.x;
              // console.log(this.rect)
              const width = this.rect.width + this.incr[3] * incrLeft;
              const height = this.rect.height + this.incr[1] * incrTop;
              this.sizeStyle.emit({width:`calc(${width}px)`,height:`calc(${height}px - 57px)`})
              this.modalContent.parentElement.style['max-width'] =
                (width < 50 ? 50 : width) + 'px';
              this.modalContent.parentElement.style['height'] =(height < 50 ? 50 : height+47) + 'px';
              this.modalContent.style['max-width'] =
                (width < 50 ? 50 : width) + 'px';
              this.modalContent.style['height'] =
                (height < 50 ? 50 : height) + 'px';
              this.modalContent.parentElement.style['margin-top'] =
                (this.rect.top - 28) + this.incr[0] * incrTop + 'px';
              this.modalContent.parentElement.style['margin-left'] =
                this.rect.left + this.incr[2] * incrLeft + 'px';
                // this.style = {
                //   width: '100%',
                //   height: '100%'
                // };
                // this.style = {
                //   width: (width < 50 ? 50 : width ) + 'px',
                //   height: (height < 75 ? 75 : height ) + 'px'
                // };
                // this.modalContent.parentElement.style['max-width'] =
                //   (width < 50 ? 50 : width) + 'px';
                // this.modalContent.parentElement.style['margin-left'] =
                //   this.rect.left + this.incr[2] * incrLeft + 'px';
              // this.modalContent.parentElement.style
            });
        }
      });
  }

  findModalContent(element: HTMLElement) {
    return element.getAttribute('role') == "document" || element.className == 'modal-dialog'
      ? element
      : element.parentElement
      ? this.findModalContent(element.parentElement)
      : null;
  }
}
